(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-theme"] && !Shopify.designMode) return;
  try {
    
 scrollFloor({
    floorClass : '.scroll-floor',       //楼层盒子class;默认为'.scroll-floor'
    navClass : '.scroll-nav',           //导航盒子class;默认为'.scroll-nav'
    activeClass : 'active',             //导航高亮class;默认为'active'
    delayTime:300,                      //点击导航，滚动条滑动到该位置的时间间隔;默认为200
    activeTop:140,                      //楼层到窗口的某个位置时，导航高亮（设置该位置）;默认为100
    scrollTop:-80                        //点击导航，楼层滑动到窗口的某位置;默认为100
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  var $qtyadd = $(".more");
    var $qtyminus = $(".less");
    $qtyadd.each(function(){
      $(this).click(function(){
        var $qtynum = $(this).parent().find(".input-num");
        var qtynum = $qtynum.val();
        var qtycur = parseInt(qtynum)+1;
        $qtynum.val(qtycur);
        $qtynum.attr("value",qtycur);
      });
    });

  $qtyminus.each(function(){
    $(this).click(function(){
      var $qtynum = $(this).parent().find(".input-num");
      var qtynum = $qtynum.val();
      if(qtynum <= 1){
      }else{
        var qtycur = parseInt(qtynum)-1;
        $qtynum.val(qtycur);
        $qtynum.attr("value",qtycur);
      }
    });
  });

/* ================================
   Best Sellers Lazy Load
================================ */

(function () {
  var container = document.getElementById('BestSellersLazy');

  if (!container) return;

  function load() {
    if (container.dataset.loaded) return;

    container.dataset.loaded = 'true';

    fetch(container.dataset.sectionUrl, {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        container.innerHTML = html;
        container.removeAttribute('aria-busy');

        if (
          window.theme &&
          typeof window.theme.bestProduct === 'function'
        ) {
          window.theme.bestProduct();
        }
      })
      .catch(function () {
        container.innerHTML = '';
      });
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries, observer) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          load();
        }
      },
      {
        rootMargin: '600px 0px'
      }
    ).observe(container);
  } else {
    load();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
